import { useState, useEffect, useRef, useCallback } from 'react';

export function useInfiniteScroll(fetchCallback) {
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(0);
  const observer = useRef();

  const lastElementRef = useCallback(node => {
    if (loading) return;
    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver(entries => {
      // ONLY increment if it's intersecting AND we aren't already loading
      if (entries[0].isIntersecting && hasMore && !loading) {
        setPage(prev => prev + 1);
      }
    });

    if (node) observer.current.observe(node);
  }, [loading, hasMore]);

  useEffect(() => {
    let isMounted = true;
    if(page === 0) setHasMore(true);
    
    const runFetch = async () => {
      setLoading(true);
      const newpage = await fetchCallback(page);
      if (isMounted) {
        if (!newpage) {
          setHasMore(false);
        }
        setLoading(false);
      }
    };

    runFetch();
    return () => { isMounted = false; };
  }, [page, fetchCallback]);

  return { lastElementRef, loading, hasMore, setPage, setHasMore };
}